import {actions as A} from '../constants/actions';

const defaultState = {
  firstName: null,
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SET_USER_NAME:
      return {...state, firstName: payload};

    default:
      return state;
  }
}
